import Immutable, { List, Map, fromJS, toJS } from 'immutable';

import * as types from './actionTypes';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';
import { toDashboardCards } from './transform';
import { stack } from 'react-immutable-proptypes';

let newState;

const Dashboard = (state, action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        newState = state.set('strings', locale(action?.data?.language, 'dashboards'));
        return newState;
      }

      case types.FETCH_DASHBOARD_REQUEST:
        return state;

      case types.FETCH_DASHBOARD_SUCCESS: {
        const widgets = state.get('widgets') || List();
        const contracts = action?.data?.data?.contracts || [];

        // returns an Immutable List with 'unpaid' preserved
        const updatedWidgets = toDashboardCards(contracts, widgets);

        // just replace the widgets list
        return state.set('widgets', updatedWidgets);
      }

      case types.FETCH_DASHBOARD_FAIL:
        newState = state.setIn(['alerts'], fromJS(action.error));
        return state;

      case types.FETCH_UNPAID_CONTRACTS_REQUEST:
        return state;

      case types.FETCH_UNPAID_CONTRACTS_SUCCESS: {
        const unpaidCount = action?.data?.data?.contracts?.length ?? 0;

        const widgets = state.get('widgets') || List();
        const idx = widgets.findIndex(w => w?.get('type') === 'unpaid');

        if (idx === -1) {
          // Create the widget if it doesn’t exist

          const newWidget = fromJS({
            component: 'DlpkInfoCard',
            type: 'unpaid',
            config: {
              title: 'dashboardCard.title.warning',
              theme: 'red',
              data: [{ query: { status: ['declined', 'active', 'resiliated', 'terminated'], isOutstanding: ['true'] }, route: '/contracts', value: unpaidCount }],
            },
            position: 4,
          });
          return state.set('widgets', widgets.push(newWidget));
        }

        // Update existing widget defensively
        const updatedWidgets = widgets.update(idx, w =>
          (w || Map()).setIn(['config', 'data', 0, 'value'], unpaidCount)
        );

        // put the updated list back into state
        return state.set('widgets', updatedWidgets);
      }

      case types.FETCH_UNPAID_CONTRACTS_FAIL:
        newState = state.setIn(['alerts'], fromJS(action.error));
        return state;

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack)
    return stack
  }

};
export default Dashboard;
